/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-07-08 10:25:15
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-09-14 09:33:46
 */
/* eslint-disable */
import fetchHelper from '../utils/fetchHelper'
import { captureFetchException } from '../utils/sentryUtils'

// 获取整改记录列表
export function fetchRectificationList(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/rectification/list',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 批量删除整改记录（同时支持单个和批量删除）
export function batchDeleteRectification(data) {
  return (dispatch, getState) => {
    // 获取全局状态中的groupID和userID
    const state = getState()
    const groupId = state.group.groupId
    const userId = state.main.user?.user_id

    // 构建符合API要求的请求体
    const requestBody = {
      recordIDs: data.recordIDs,
      groupID: groupId,
      userID: userId
    }

    let config = {
      // 修改为正确的API路径
      url: __API_SERVER_HOST__ + '/web/rectification/batch/delete',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

/**
 * 导出整改记录表格
 * @param {Object} params - 筛选参数
 * @returns {Promise} - 返回导出结果
 */
export function exportRectification(params) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/rectification/export',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

/**
 * 根据选中ID导出整改记录表格
 * @param {Object} params - 包含选中ID的参数
 * @returns {Promise} - 返回导出结果
 */
export function exportRectificationByIds(params) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/rectification/export/ids',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 获取用户列表
export function fetchUserList(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/rectification/users',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

/**
 * 分享整改记录
 * @param {Object} params - 分享参数
 * @returns {Promise} - 返回分享结果
 */
export function shareRectification(params) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/rectification/share',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

/**
 * 创建整改记录
 * @param {Object} data - 创建整改记录的参数
 * @param {string} data.deadline - 截止时间，格式: "2025-09-02 21:05:00"
 * @param {string} data.groupID - 团队ID
 * @param {string[]} data.photoFilesBefore - 整改前照片URL数组
 * @param {string[]} data.qrcodeList - 二维码列表（与照片数量对应的空字符串数组）
 * @param {string[]} data.rectificationUserIDs - 待办人ID数组
 * @param {string} data.remark - 备注信息
 * @param {string} data.userID - 用户ID
 * @returns {Promise} - 返回创建结果
 */
export function createRectification(data) {
  return (dispatch, getState) => {
    // 构建请求配置
    let config = {
      url: __API_SERVER_HOST__ + '/web/rectification/create',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        // 返回完整的结果，包含recordID等信息
        return Promise.resolve(result)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(err)
      })
  }
}

/**
 * 查询整改次数和会员状态
 * @param {string} groupID - 团队ID
 * @param {string} userID - 用户ID
 * @returns {Promise} - 返回查询结果
 */
export function fetchRemediationStatus(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/group/remediation/query',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(err)
      })
  }
}

/**
 * 设置整改次数
 * @param {string} groupID - 团队ID
 * @param {string} userID - 用户ID
 */
export function fetchRemediationSet(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/group/remediation/set',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        return Promise.resolve(result.data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(err)
      })
  }
}
